module.exports = __webpack_public_path__ + "img/home-icon-bai.2823c0d0.png";